import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Save } from 'lucide-react'
import { CreateSnapshotModal } from './CreateSnapshotModal'
import { useCreateSnapshot } from '@/hooks/useAttendanceMetrics'
import { toast } from 'sonner'

interface SaveSnapshotButtonProps {
  startDate: string
  endDate: string
  hasData: boolean
}

export function SaveSnapshotButton({ startDate, endDate, hasData }: SaveSnapshotButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const createSnapshot = useCreateSnapshot()

  const handleSubmit = async (data: { name?: string }) => {
    try {
      await createSnapshot.mutateAsync({
        name: data.name,
        startDate,
        endDate,
      })
      toast.success('Relatório criado com sucesso!')
      setIsModalOpen(false)
    } catch (error) {
      toast.error('Erro ao criar relatório')
    }
  }

  return (
    <>
      <Button
        variant="default"
        size="sm"
        onClick={() => setIsModalOpen(true)}
        className="gap-2"
      >
        <Save className="h-4 w-4" />
        <span className="hidden sm:inline">Salvar Relatório</span>
        <span className="sm:hidden">Salvar</span>
      </Button>

      <CreateSnapshotModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        period={{ startDate, endDate }}
        onSubmit={handleSubmit}
        isSubmitting={createSnapshot.isPending}
        hasData={hasData}
      />
    </>
  )
}
